import React from "react";
import { DsPageHeader } from "../../../../design-system";
import ProductThemePicker from "../../../../design-system/ProductThemePicker";
import { usePermissions } from "../../../../rbac/PermissionsContext";

/**
 * Configuration → Settings: product appearance + pointers to moved org defaults.
 */
const EnterpriseConfigurationSettings = () => {
  const { hasScreenAccess, isAdmin } = usePermissions();
  const canEdit =
    isAdmin || hasScreenAccess("configuration", "settings", "edit");
  const canView =
    isAdmin ||
    hasScreenAccess("configuration", "settings", "view") ||
    canEdit;

  if (!canView) {
    return (
      <div className="ds-page-panel min-h-0 flex-1 overflow-y-auto">
        <div className="px-5 py-6 lg:px-6">
          <p className="ds-body text-[hsl(var(--ds-muted-fg))]">
            You do not have access to Configuration Settings.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="ds-page-panel min-h-0 flex-1 overflow-y-auto">
      <div className="ds-page-panel-head">
        <DsPageHeader
          title="Settings"
          description="Product appearance and organisation-level preferences."
        />
      </div>
      <div className="space-y-6 px-5 py-6 lg:px-6">
        <ProductThemePicker canEdit={canEdit} />

        <div className="rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted))]/40 p-4">
          <p className="ds-body text-[hsl(var(--ds-fg))]">
            Minimum wages and default salary structure method have moved to{" "}
            <strong>Payroll → Settings → General Settings</strong>.
          </p>
          <p className="ds-caption mt-2 text-[hsl(var(--ds-muted-fg))]">
            Open Payroll Settings from the left rail or the Settings hub to edit those
            preferences. Each setting still has its own Save button.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseConfigurationSettings;
